import grapesjs from 'drapcode-builder';
import loadTraits from './traits';
import loadComponents from './components';

export default grapesjs.plugins.add('drapcode-charts', (editor, opts = {}) => {
  const default_blocks = {
    lineChart: true,
    areaChart: true,
    pieChart: false,
    heatMapChart: false,
    circularGaugeChart: false,
  };

  const default_types = {
    lineChart: 'line_chart',
    areaChart: 'area_chart',
    pieChart: 'pie_chart',
    heatMapChart: 'heat_map_chart',
    circularGaugeChart: 'circular_gauge_chart',
  };

  const default_labels = {
    lineChart: 'Line Chart',
    areaChart: 'Area Chart',
    pieChart: 'Pie Chart',
    heatMapChart: 'HeatMap Chart',
    circularGaugeChart: 'Circular Gauge Chart',
  };

  const default_traits = {
    circularGaugeChart: {
      type: 'drapcode-circular-chart',
      label: false,
    },
  };

  let options = {
    ...{
      blocks: default_blocks,
      labels: default_labels,
      types: default_types,
      traits: default_traits,
      labelDrapcodeChartCategory: 'Charts',
    },
    ...opts,
  };

  for (let name in options) {
    if (!(name in opts)) opts[name] = options[name];
  }
  loadTraits(editor, opts);
  loadComponents(editor, opts);
});
